/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetLogListItemResponseDto } from './AssetLogListItemResponseDto';
import {
    AssetLogListItemResponseDtoFromJSON,
    AssetLogListItemResponseDtoFromJSONTyped,
    AssetLogListItemResponseDtoToJSON,
    AssetLogListItemResponseDtoToJSONTyped,
} from './AssetLogListItemResponseDto';

/**
 * 
 * @export
 * @interface PaginatedAssetLogsResponseDto
 */
export interface PaginatedAssetLogsResponseDto {
    /**
     * 
     * @type {Array<AssetLogListItemResponseDto>}
     * @memberof PaginatedAssetLogsResponseDto
     */
    items: Array<AssetLogListItemResponseDto>;
    /**
     * Whether another page is available after these items
     * @type {boolean}
     * @memberof PaginatedAssetLogsResponseDto
     */
    hasNextPage: boolean;
    /**
     * Opaque cursor to fetch the next page; null when no next page
     * @type {string}
     * @memberof PaginatedAssetLogsResponseDto
     */
    nextCursor?: string | null;
    /**
     * Requested page size
     * @type {number}
     * @memberof PaginatedAssetLogsResponseDto
     */
    limit: number;
}

/**
 * Check if a given object implements the PaginatedAssetLogsResponseDto interface.
 */
export function instanceOfPaginatedAssetLogsResponseDto(value: object): value is PaginatedAssetLogsResponseDto {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('hasNextPage' in value) || value['hasNextPage'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function PaginatedAssetLogsResponseDtoFromJSON(json: any): PaginatedAssetLogsResponseDto {
    return PaginatedAssetLogsResponseDtoFromJSONTyped(json, false);
}

export function PaginatedAssetLogsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedAssetLogsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(AssetLogListItemResponseDtoFromJSON)),
        'hasNextPage': json['hasNextPage'],
        'nextCursor': json['nextCursor'] == null ? undefined : json['nextCursor'],
        'limit': json['limit'],
    };
}

export function PaginatedAssetLogsResponseDtoToJSON(json: any): PaginatedAssetLogsResponseDto {
    return PaginatedAssetLogsResponseDtoToJSONTyped(json, false);
}

export function PaginatedAssetLogsResponseDtoToJSONTyped(value?: PaginatedAssetLogsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(AssetLogListItemResponseDtoToJSON)),
        'hasNextPage': value['hasNextPage'],
        'nextCursor': value['nextCursor'],
        'limit': value['limit'],
    };
}

